import React from 'react'
import { CustomInput } from '../CustomComponents/Custom'

function FieldCustomInput({ field,  form, ...props }) {
  return (
    <CustomInput {...field} {...props} />
  )
}

export default FieldCustomInput